import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import ClearAllBtn from '../ClearAllBtn/ClearAllBtn';
import { IconClose } from '../Icons';
import { getFilterValue } from '../../Utils/CollectionUtils';
import { StyledUl, StyledButton } from './ActiveFiltersStyles';

var _ref = React.createElement(IconClose, null);

var ActiveFilters = function ActiveFilters(props) {
  return React.createElement(
    StyledUl,
    null,
    props.activeFilters.length ? React.createElement(
      Fragment,
      null,
      props.activeFilters.map(function (filter) {
        return React.createElement(
          'li',
          { key: filter },
          React.createElement(
            StyledButton,
            {
              onClick: function onClick() {
                return props.handleFilterClick(filter);
              },
              'aria-label': 'Toggle Filter'
            },
            getFilterValue(filter),
            _ref
          )
        );
      }),
      React.createElement(
        'li',
        null,
        React.createElement(ClearAllBtn, {
          onClick: props.handleFilterClearAll,
          'aria-label': 'Clear All Filters'
        })
      )
    ) : null
  );
};

ActiveFilters.propTypes = {
  handleFilterClick: PropTypes.func.isRequired,
  handleFilterClearAll: PropTypes.func.isRequired,
  activeFilters: PropTypes.array.isRequired
};

export default ActiveFilters;